import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <FaqSection />
        <CarouselSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}